<template src="./roomInventoryDetail.template.html"></template>
<script>  
 import moment from "moment-timezone";
    export default {
        name: "roomInventoryDetail",
        props: [],
        data() {
            return {
                propertyList: [],
                unitList: [],
                roomInventoryDetails: {
                    propertyId: -1,
                    unitId: -1,
                    startDate: null,
                    endDate: null,
                    IsBlackOut: 0
                },
                opens:"right"
            };
        },
        methods: {
            updateValues(values){
                this.roomInventoryDetails.startDate=values.startDate
                .toISOString()
                .slice(0, 10);
                this.roomInventoryDetails.endDate=values.endDate
                .toISOString()
                .slice(0, 10);
            },
            getPropertyMetaData: function () {
                let scope = this;
                this.$store.dispatch("dataRequestHandler", {
                    key: "GetPropertiesBySearchText",
                    params: {

                    },
                    callback: function (err, response) {
                        if (response) {
                            scope.propertyList.splice(0, scope.propertyList.length, ...response.propertyList);
                        } else {
                            console.log(err);
                        }
                    }
                });
            },
            getPropertyUnits() {
                let scope = this;
                this.$store.dispatch("dataRequestHandler", {
                    key: "GetUnitList",
                    params: {
                        PropertyId: scope.roomInventoryDetails.propertyId,
                        StatusId: 1
                    },
                    callback: function (err, response) {
                        if (response) {
                            scope.unitList.splice(0, scope.unitList.length, ...response.recordsets[1]);
                        } else {
                            console.log(err);
                        }
                    }
                });
            },
           
            saveroomInventoryDetails() {
                let scope = this;
                console.log("scope.roomInventoryDetails", scope.roomInventoryDetails)
                if (scope.roomInventoryDetails.propertyId == -1) {
                    scope.$store.dispatch("toastr", {
                        type: "error",
                        header: "Validations failed!",
                        message: "Please select Property"
                    });
                    return;
                }
                else if (scope.roomInventoryDetails.unitId == -1) {
                    scope.$store.dispatch("toastr", {
                        type: "error",
                        header: "Validations failed!",
                        message: "Please select Unit"
                    });
                    return;
                }
                else if(scope.roomInventoryDetails.endDate === "" ||
                    scope.roomInventoryDetails.endDate === undefined ||
                    scope.roomInventoryDetails.endDate === null ||
                    scope.roomInventoryDetails.startDate === "" ||
                    scope.roomInventoryDetails.startDate === undefined ||
                    scope.roomInventoryDetails.startDate === null){
                    scope.$store.dispatch("toastr", {
                        type: "error",
                        header: "Validations failed!",
                        message: "Please select start and end dates"
                    });
                    return;
                }

                scope.$store.dispatch("dataRequestHandler", {
                    key: "Save_InventoryDetails",
                    // params: scope.roomInventoryDetails,
                    params:{
                        CloseOutId :-1,
                        propertyId: scope.roomInventoryDetails.propertyId,
                    unitId: scope.roomInventoryDetails.unitId,
                    startDate: moment(scope.roomInventoryDetails.startDate).format("YYYY-MM-DD"),
                    endDate: moment(scope.roomInventoryDetails.endDate).format("YYYY-MM-DD"),
                    IsBlackOut: scope.roomInventoryDetails.IsBlackOut
                    },
                    callback: function (err, response) {
                        if (response) {
                            console.log("saved rate override details", response);
                            if(response && response[0][0] && response[0][0].ErrorMessage === " "){
                                scope.$store.dispatch("toastr", {
                                type: "success",
                                header: "Success!",
                                message: "Unit Inventory details successfully saved"
                            });
                            }
                            else{
                                scope.$store.dispatch("toastr", {
                                type: "error",
                                header: "Unit Inventory details Error!",
                                message: response[0][0].ErrorMessage
                            });
                            }
                            
                        } else {
                            console.log(err);
                            scope.$store.dispatch("toastr", {
                                type: "error",
                                header: "Unit Inventory details Error!",
                                message: err.sqlMessage ? err.sqlMessage : err
                            });
                        }
                    }
                });
            },
            updateStartDate(key, dateObj){
                let scope = this;
                scope.roomInventoryDetails.startDate = dateObj ? dateObj.format("DD MMM YYYY") : null;
            },
            updateEndDate(key, dateObj){
                let scope = this;
                scope.roomInventoryDetails.endDate = dateObj ? dateObj.format("DD MMM YYYY") : null;
            }
        },
        computed: {},
        watch: {},
        mounted() {
            let vm = this;
            console.log("Unit Inventory module loaded");
            vm.getPropertyMetaData();
        
        }
    }
</script>